import { schema } from "normalizr";

import type { IIssue } from "App/Modules/Models";
import type { CombinedSite } from "../Models";

export const siteSchema = new schema.Entity<CombinedSite>("sites");
export const issueSchema = new schema.Entity<IIssue>("issues");
